export const downloadBlobUrlFileToBrowser = (url: string): void => {
  const elem = window.document.createElement('a');
  elem.href = url;

  // Let Observable to complete before triggering download, this avoids conflicts with operationTrackingInterceptor.
  // This is needed because `a` element click triggers a navigation event.
  setTimeout(() => {
    elem.click();
  }, 0);
};
